import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@otp/ui';
import { PermissionForm } from '../form';
import {
  Actions,
  AppArea,
  PermissionsDocument,
  Subjects,
} from 'src/graphql/generated/graphql';
import { Can } from 'src/utils/can';

export const CreatePermissionButton = ({}) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = React.useState(false);

  return (
    <Can I={Actions.Write} a={Subjects.Permissions} appArea={AppArea.Admin}>
      <Button
        variant="contained"
        className=""
        onClick={() => setShowModal(true)}
      >
        {t('permissions.list.create-button')}
      </Button>

      {showModal && (
        <PermissionForm
          onClose={() => setShowModal(false)}
          onFinish={() => setShowModal(false)}
          refetchQueries={[PermissionsDocument]}
        />
      )}
    </Can>
  );
};
